module.exports = __webpack_public_path__ + "img/lock-position.f7a28dab.png";